import { useEffect } from "react";

const useUnityEventBindings = ({
  addEventListener,
  removeEventListener,
  onElementSelected,
  onElementDeselected,
  onEnvironmentChanged,
  onRecordingStarted,
  onUploadAudioFile,
  onReadyToLoadExperience,
  onSystemLoaded,
  onSystemFullyLoaded,
  onAssessmentComplete,
  onInstructionVisibilityChanged,
  onInsightStarted,
  onGameStateChanged,
  onGuideStateChanged,
  onSessionStarted,
}) => {
  useEffect(() => {
    addEventListener("elementSelected", onElementSelected);
    addEventListener("elementDeselected", onElementDeselected);
    addEventListener("environmentChanged", onEnvironmentChanged);
    addEventListener("recordingStarted", onRecordingStarted);
    addEventListener("uploadAudioFile", onUploadAudioFile);
    addEventListener("readyToLoadExperience", onReadyToLoadExperience);
    addEventListener("systemLoaded", onSystemLoaded);
    addEventListener("systemFullyLoaded", onSystemFullyLoaded);
    addEventListener("assessmentComplete", onAssessmentComplete);
    addEventListener("instructionVisibilityChanged", onInstructionVisibilityChanged);
    addEventListener("insightStarted", onInsightStarted);
    addEventListener("gameStateChanged", onGameStateChanged);
    addEventListener("guideStateChanged", onGuideStateChanged);
    addEventListener("sessionStarted", onSessionStarted);
    addEventListener("SessionStarted", onSessionStarted);

    return () => {
      removeEventListener("elementSelected", onElementSelected);
      removeEventListener("elementDeselected", onElementDeselected);
      removeEventListener("environmentChanged", onEnvironmentChanged);
      removeEventListener("recordingStarted", onRecordingStarted);
      removeEventListener("uploadAudioFile", onUploadAudioFile);
      removeEventListener("readyToLoadExperience", onReadyToLoadExperience);
      removeEventListener("systemLoaded", onSystemLoaded);
      removeEventListener("systemFullyLoaded", onSystemFullyLoaded);
      removeEventListener("assessmentComplete", onAssessmentComplete);
      removeEventListener("instructionVisibilityChanged", onInstructionVisibilityChanged);
      removeEventListener("insightStarted", onInsightStarted);
      removeEventListener("gameStateChanged", onGameStateChanged);
      removeEventListener("guideStateChanged", onGuideStateChanged);
      removeEventListener("sessionStarted", onSessionStarted);
      removeEventListener("SessionStarted", onSessionStarted);

    };
  }, [
    addEventListener,
    removeEventListener,
    onElementSelected,
    onElementDeselected,
    onEnvironmentChanged,
    onRecordingStarted,
    onUploadAudioFile,
    onReadyToLoadExperience,
    onSystemLoaded,
    onSystemFullyLoaded,
    onAssessmentComplete,
    onInstructionVisibilityChanged,
    onInsightStarted,
    onGameStateChanged,
    onGuideStateChanged,
    onSessionStarted,
  ]);
};

export default useUnityEventBindings;
